// extracted by mini-css-extract-plugin
export default {"contact":"Contactme_contact__iShGH","mainBox":"Contactme_mainBox__VJwJk"};